import React from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Modal } from '@telus-uds/components-web';

import request from '../../utils/request';
import {
  ChannelTag,
  SummaryDetail
} from './css';
import { SummaryGroupWrapper, SummaryCategory } from '../../form/css';
import { profileKeysToList } from '../../utils/constant';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { StickyOrderModalHeader } from '../shared/modalOverrides';

const AccountInfo = ({ onClose }) => {
  const localizedStrings = useLocalizedStringsContext();
  const { profileKeys } = localizedStrings;
  const profile = request.getProfile();

  const getChannels = channels => {
    if (channels.length === 1) return channels[0].description;
    return channels.map(channel => (
      <ChannelTag>{channel.description}</ChannelTag>
    ));
  };

  // SOF-3356 Phase 9 T056: Resolve dealership column (FK id) to the joined
  // Dealership.name when present so the My Account Info popup shows the
  // human-readable dealership name. Backend exports.profile already includes
  // the `Dealership` association (id + name) for all roles. Falls back to
  // the raw `dealership` column for legacy responses missing the join.
  const getDisplayValue = key => {
    if (key === 'role_id') return _.get(profile, 'role.description');
    if (key === 'dealership') {
      return _.get(profile, 'Dealership.name', profile.dealership);
    }
    return profile[key];
  };

  return (
    <>
      <StickyOrderModalHeader />
      <Modal
        isOpen={true}
        onClose={onClose}
        variant={{ width: 'xl' }}
        heading="My Account Info"
      >
        <div style={{ padding: "1rem 0", maxHeight: "58vh" }}>
          {profile &&
          profileKeysToList.map(key => {
            const profileValue = getDisplayValue(key);
            if (profileValue)
              return (
                <SummaryGroupWrapper key={`rep-info-${key}`}>
                  <SummaryCategory>
                    <span className="frg-body-font-14px">
                      {profileKeys[key]}
                    </span>
                  </SummaryCategory>
                  <SummaryDetail>
                    {key === 'channelName' ? (
                      getChannels(profile.channels)
                    ) : (
                      <span className="frg-body-font-14px">
                        {profileValue}
                      </span>
                    )}
                  </SummaryDetail>
                  <div className="clear" />
                </SummaryGroupWrapper>
              );
            return null;
          })}
        </div>
      </Modal>
    </>
  );
};

AccountInfo.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default AccountInfo;
